import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";

export function QuestionizerResultTeaser(){
    const include_all_results_in_print = useQuestionizerStore((state) => state.config?.include_all_results_in_print || false);
    const include_in_print = useQuestionizerStore((state) => state.include_in_print);
    const setIncludeInPrint = useQuestionizerStore((state) => state.setIncludeInPrint);
    const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">("zuschusse");
    const result = useQuestionizerStore((state) => state.result);
    const initialSelectAll =  include_all_results_in_print || false;
    const [select_all, setSelectAll] = useState(initialSelectAll); 

    type SortedResultsList = Record<string,{region: string, list: Array<FDWResultEntry>}>;

    if (result == undefined){
      return <div></div>
    }
  
    const zuschuesse = result.filter((entry) => entry.fp_type == "Zuschuss").reduce((acc: SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    const darlehen = result.filter((entry) => entry.fp_type == "Darlehen").reduce((acc : SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

	// Zuschüsse & Darlehen zusammenführen
	let all_zuschuesse = Object.keys(zuschuesse).flatMap(key => zuschuesse[key].list);
	let all_darlehen = Object.keys(darlehen).flatMap(key => darlehen[key].list);
	let all_programme = [...all_zuschuesse, ...all_darlehen];

	let zuschuesse_length = all_zuschuesse.length;
	let darlehen_length = all_darlehen.length;

	let bundesprogramme_length = all_programme.filter(z => z.region === "Bundesweit verfügbare Programme").length;
	let landesprogramme_length = all_programme.filter(z => z.region === "Im Bundesland verfügbare Programme").length;
	let gemeindeprogramme_length = all_programme.filter(z => z.region === "In der Gemeinde verfügbare Programme").length;


    return (<div tabIndex={0} className="mb-8 text-center">
      <p className="text-xl">{`Wir haben für Sie ${zuschuesse_length} passende Zuschuss- und  ${darlehen_length} Darlehen-Förderprogramme auf Bundes-, Landes- und kommunaler Ebene recherchiert:`}</p>
			<div className="text-xl font-bold">{bundesprogramme_length} Bundesprogramme</div>
			<div className="text-xl font-bold">{landesprogramme_length} Landesprogramme</div>
			<div className="text-xl font-bold">{gemeindeprogramme_length} kommunale Programme</div>
    </div>); 
  }